import { GET_NETWORKLAYER_DATA } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const fetchNetworkLayerData = async () => {
  try {
    const resp = await apiClient.get(GET_NETWORKLAYER_DATA, {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
